import {DeleteOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import {Button, Modal} from "antd";

type OfferingDeleteButtonProps = {
  title: string;
  content: string;
  okText: string;
  cancelText: string;
  onOk: () => Promise<unknown>;
};

export function OfferingDeleteButton({
  cancelText,
  content,
  okText,
  onOk,
  title,
}: OfferingDeleteButtonProps) {
  const showDeleteConfirm = () => {
    Modal.confirm({
      title,
      content,
      icon: <ExclamationCircleOutlined style={{color: "#F5222D"}} />,
      okText,
      cancelText,
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
        // loading: isLoading,
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk,
    });
  };
  return (
    <Button
      onClick={showDeleteConfirm}
      icon={<DeleteOutlined />}
      block
      type="text"
      size="small"
      danger
    ></Button>
  );
}
